import { API_ENDPOINT } from '@Env/variables';
import { createAxiosInstance } from './axios';
import { AIAnalytics, AIFeatureKeys } from '@Models/types';

export const aiAnalyticsAPI = (logout: () => void) => {
  const axios = createAxiosInstance(logout, API_ENDPOINT);

  return {
    getAllAnalytics: async (): Promise<AIAnalytics[]> => {
      const res = await axios.get('/api/ai-analytics/all?limit=1000');
      return res.data.success ? res.data.data : [];
    },

    getAnalyticsByFeature: async (
      featureKey: AIFeatureKeys
    ): Promise<AIAnalytics[]> => {
      const res = await axios.get(
        `/api/ai-analytics/by-feature?featureKey=${featureKey}`
      );
      return res.data.success ? res.data.data : [];
    },

    getTokenUsage: async () => {
      const res = await axios.get('/api/ai-analytics/token-usage');
      return res.data.success ? res.data.data : null;
    },

    getUserTokenUsage: async (timeSpan?: string) => {
      const queryParam = timeSpan ? `?timeSpan=${timeSpan}` : '';
      const res = await axios.get(`/api/ai-analytics/user-usage${queryParam}`);
      return res.data.success ? res.data.data : [];
    },

    insertAnalytics: async (analytics: Omit<AIAnalytics, 'id'>) => {
      const res = await axios.post('/api/ai-analytics/insert', analytics);
      return res.data;
    },
  };
};
